
import { hideDialog, refresher } from "../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../assets/js/Icons";

import {
  DELETE_SCHEDULE,
} from "../../../utils/keywords";

import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";

import { handleDeleteSchedule } from "../../../redux/specialist-slices/scheduleSlots.slice";

function Delete() {
  const dispatch = useDispatch();
  const { type, data, loadings } = useSelector((state) => state.otherSlice);

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  // Handle delete
  const handleDelete = () => {
    const deleteActions = {
      [DELETE_SCHEDULE]: () => handleDeleteSchedule(data),

    };

    const action = deleteActions[type];
    if (!action) return;

    dispatch(action())
      .unwrap()
      .then(() => {
        setTimeout(() => {
          handleClose();
          dispatch(refresher());
        }, 500);
      })
      .catch(() => { });
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          {type === DELETE_SCHEDULE ? "Delete Schedule" : null}
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <Box sx={{ display: "grid", placeContent: "center", mb: 2 }}>
          <Icon
            sx={{ fontSize: "60px", overflow: "visible", color: "error.main" }}
          >
            <Icons.Alert />
          </Icon>
        </Box>

        <Typography
          sx={{
            m: "0",
            color: "#333333",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
            fontFamily: "Poppins",
          }}
        >
          {type === DELETE_SCHEDULE
            ? "Warning: This Schedules will permanently delete. Are you sure you want to proceed?"
            : null}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          color="error"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={
            loadings?.delete ? (
              <CircularProgress
                size={20}
                thickness={5}
                sx={{ color: "white" }}
              />
            ) : (
              <Icons.DeleteSolid />
            )
          }
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default Delete;
